import { Layout } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { Color } from '../../../Common/Color'
import TabletPublicHeader from '../Header/Tablet/TabletPublicHeader'

export default function TabletHeaderLayout () {
  return (
    <Layout>
      <TabletPublicHeader />
      <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  )
}
